<button type="button" class="btn btn-info"
        [popover]="content" [popoverTitle]="title">
  Simple binding
</button>
